"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setup = setup;

var _clapprHlsFix = require("clappr-hls-fix");

function setup(_ref) {
  var audioSrc = _ref.audioSrc,
      trackPath = _ref.trackPath,
      trackID = _ref.trackID,
      overrides = _ref.overrides,
      tool = _ref.tool,
      id = _ref.id;
  var Loader = (0, _clapprHlsFix.getFixedClapprLoader)();
  var Options = {
    width: 800,
    height: 75,
    autoPlay: false,
    hideMediaControl: false,
    audioOnly: true,
    source: audioSrc
  };
  var wait = false;
  var lastRange = {
    start: 0,
    end: 0
  };
  var trackInterval;
  Object.assign(Options, overrides);

  if (/Firefox\./.test(navigator.userAgent)) {
    wait = true;
    var root = Options.source;
    $.get(root, function (body) {
      body = body.split('\n').filter(function (v) {
        return !!v;
      });
      Options.source = body[body.length - 1];
      attach();
    });
  }

  Loader.playbackPlugins = [Clappr.HLSAudio, Clappr.HTML5Audio, Clappr.FlasHLS]; // Monkey patch

  Clappr.HLSAudio.prototype.onDurationChange = function () {
    this._onDurationChange();
  };

  if (!wait) attach();

  function unload() {
    track();
  }

  function stop() {
    track();
  }

  function ended() {
    track();
  }

  function pause() {
    track();
  }

  function timeupdate(progress) {
    lastRange.end = progress.current;
  }

  function seek(tgt) {
    track();
    lastRange.start = lastRange.end = tgt;
  }

  function play() {
    clearInterval(trackInterval);
    trackInterval = setInterval(track, 10 * 1000);
  }

  function track() {
    var r = lastRange;

    if (r.start != r.end) {
      var tgt = trackPath + "?".concat(Object.keys(r).map(function (k) {
        return "".concat(encodeURIComponent(k), "=").concat(encodeURIComponent(String(r[k])));
      }).join('&'), ")");
      $.get(tgt, function () {});
    }

    lastRange = {
      start: r.end,
      end: r.end
    };
  }

  function played() {
    $('.header-item.audio').addClass('started'); // FIXME: BLX.trackObjectView(tool, 'record', id);
  }

  function attach() {
    var Player = new Clappr.Player(Options);
    Player.loader = Loader;
    $('#audio-player').data('player', Player);
    Player.attachTo($('#audio-player')[0]);
    if (Options.autoPlay) played();else Player.once('play', played);
    Player.on('play', play);
    Player.on('seek', seek);
    Player.on('timeupdate', timeupdate);
    Player.on('pause', pause);
    Player.on('ended', ended);
    Player.on('stop', stop);
    $(window).on('unload', unload);
  }
}